<template>
  <div class="w-100 mx-3 pt-2 pb-4">
    <div class="animated fadeIn">
        <div class="pt-4 justify-content-between" style="display: flex; gap: .3rem;">
          <div>
            <h5 class="text-third m-0"><i class="fas fa-address-card" /> Regras de Transferência de Quadro</h5>
          </div>
          <div class="text-right">
            <button type="button" class="btn rounded btn-third btn-sm" v-on:click="openNewRuleModal" v-b-tooltip.hover title="Clique para adicionar uma nova regra"> <i class="fas fa-plus-circle" /> Adicionar</button>&nbsp;
          </div>
        </div>

        <div class="table-responsive pt-2" v-if="rules && rules.length">
            <table class="table table-hover" style="border: 1px solid #dcdede;">
              <thead class="thead-third" style="border: solid 1px #04a791;">
                <tr>
                  <th class="text-center" style="font-size: 14px;">DIAS EM ATRASO</th>
                  <th class="text-center" style="font-size: 14px;">QUADRO</th>
                  <th class="text-center" style="font-size: 14px;">AÇÕES</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(obj, index) in rules" :key="index">
                  <td class="text-center">{{obj.daysOverdue}}</td>
                  <td class="text-center">{{obj.boardDestination ? obj.boardDestination.name : (obj.destinationBoard ? obj.destinationBoard.nome : '')}}</td>
                  <td class="text-center" style="font-size: 16px; cursor: pointer;">
                    <i @click="onEdit(obj)" class="fas fa-edit mr-1 text-third" ></i>
                    <i @click="toggleInative(obj)" class="ml-1"
                    :class="!obj.isActive? 'fas fa-check text-success' : 'fas fa-minus-circle text-danger'"
                    v-b-tooltip.hover :title="!obj.isActive ? 'Clique para ativar' : 'Clique para inativar'"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            Nenhum registro de regra, <strong @click="openNewRuleModal" style="cursor: pointer">clique para adicionar</strong>
          </div>

    <ModalNewTransferencia
      v-if="newRuleModalOpen"
      ref="ModalNewTransferencia"
      :isEditing="isEditing"
      :boardObj="boardObj"
      v-on:Reload="updateAndClose"
      v-on:HideModal="closeNewRuleModal"
    />
    </div>
  </div>
  </template>
<script>
import TransfAutoCardRepository from '@/shared/http/repositories/crm/transferenciaAutoCard.js'

import { toast } from '@/shared/utils/UIHelper'
import ModalNewTransferencia from '@/views/private/crm/board/modal/collumns/movimentacao-quadro/ModalNewTransferencia.vue'
import columnRuleTypes from '@/views/private/crm/board/modal/collumns/movimentacao-coluna/enumTiposRegra.js'

export default {
  name: 'TableTransferenciaQuadro',
  props: {
    boardObj: {
      type: Object,
      required: () => ({})
    }
  },
  data () {
    return {
      rules: [], // TODO: SET NULL BEFORE PROD
      newRuleModalOpen: false,
      ruleTypes: columnRuleTypes,
      isEditing: null
    }
  },
  components: { ModalNewTransferencia },
  mounted () {
    this.initializeRules()
  },
  watch: {
    boardObj: {
      handler: 'initializeRules',
      deep: true
    }
  },
  methods: {
    initializeRules () {
      if (this.boardObj) {
        // Verifica se existe transferenciaAutomaticaCard no boardObj
        if (this.boardObj.transferenciaAutomaticaCard) {
          // Transforma o objeto único em um array para manter compatibilidade com o v-for
          this.rules = [this.boardObj.transferenciaAutomaticaCard]
        } else {
          console.log('Propriedade transferenciaAutomaticaCard não encontrada no boardObj:', this.boardObj)
          this.rules = []
        }
      }
    },
    openNewRuleModal () {
      this.newRuleModalOpen = true
    },
    closeNewRuleModal () {
      this.newRuleModalOpen = false
      this.isEditing = null
    },
    updateAndClose () {
      this.closeNewRuleModal()
      this.$emit('Update')
    },
    onEdit (obj) {
      this.isEditing = obj
      this.openNewRuleModal()
    },
    toggleInative (obj) {
      let data = {
        id: obj.id,
        boardDestinationId: obj.destinationBoard ? obj.destinationBoard.id : obj.boardDestinationId,
        daysOverdue: obj.daysOverdue,
        isActive: !obj.isActive
      }

      TransfAutoCardRepository.Update(data)
        .then(() => {
          let message = !obj.isActive ? 'Regra ativada com sucesso!' : 'Regra inativada com sucesso!'
          toast.success(message, 'Parabéns')
          this.$emit('Update')
        })
        .catch((e) => {
          toast.error('Não foi possível realizar a alteração.', 'Desculpe')
          console.error(e)
        })
    }
  }
}

</script>
  <style lang="scss">
  .formulate-input-element.formulate-input-element--textarea {
    max-width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/collumns/movimentacao-quadro/TableTransferenciaQuadro.vue